// Fronteira de dia da operação — America/Sao_Paulo.
//
// O épico do Check-in (ENG-424) é explícito: todo limite de dia e de período é
// wall-clock de São Paulo, não UTC. No caminho real quem carrega a maior parte
// disso é o core (o board já vem com a hora do próximo resgate no fuso da
// operação); aqui ficam as duas contas que a TELA precisa fazer por conta
// própria — quando o ciclo acaba (pra contagem regressiva do reset) e quando é a
// próxima virada de dia (pra recarregar o board) — mais o que o resgate mockado
// usa pra imitar a virada do dia.

const OPERATION_TZ = 'America/Sao_Paulo';

// O Brasil não tem horário de verão desde 2019, então o offset é fixo.
const OPERATION_UTC_OFFSET = '-03:00';

// Dia de hoje na operação, 'YYYY-MM-DD' — mesmo formato de `starts_on`/`ends_on`
// do board, o que deixa as duas pontas comparáveis sem converter fuso.
//
// `en-CA` é o locale que formata em 'YYYY-MM-DD' sem precisar remontar as
// partes na mão.
//
// Privada desde que a faixa de status virou contagem regressiva: quem mede o
// prazo agora lê o `ends_on` do board e não precisa saber que dia é hoje. O
// único consumidor é o `nextMidnightInOperationTz` daqui de baixo — exportar sem
// ninguém do lado de fora é convite a duas fontes de "hoje".
function todayInOperationTz(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: OPERATION_TZ }).format(
    new Date(),
  );
}

// Meia-noite que FECHA o dia começado em `dayMs`, formatada com o offset da
// operação. Privada porque recebe o dia já validado — quem responde pelo que
// entra são as duas exportadas.
function midnightAfter(dayMs: number): string {
  const next = new Date(dayMs + 86_400_000);

  return `${next.toISOString().slice(0, 10)}T00:00:00${OPERATION_UTC_OFFSET}`;
}

// ISO do instante em que um dia da operação ACABA ('YYYY-MM-DD' → a meia-noite
// seguinte a ele).
//
// É a conta que transforma o `ends_on` do período no instante em que a trilha
// reseta: `ends_on` é o último dia VÁLIDO, então o ciclo morre na meia-noite
// DEPOIS dele, não na que o abre.
//
// O dia é lido como UTC só pra somar 24h de calendário; o fuso volta na string
// de saída, pelo offset — então a soma não depende do relógio de quem olha.
// `null` pra data ilegível: aqui entra campo de API, e sem a guarda um `ends_on`
// torto estouraria RangeError no `toISOString()`.
export function endOfOperationDay(day: string): string | null {
  const ms = Date.parse(`${day}T00:00:00Z`);

  return Number.isNaN(ms) ? null : midnightAfter(ms);
}

// ISO da próxima meia-noite da operação, no mesmo formato que o core devolve
// (com o offset embutido).
export function nextMidnightInOperationTz(): string {
  return midnightAfter(Date.parse(`${todayInOperationTz()}T00:00:00Z`));
}
